export const CORPORATE_STATUS_OPTIONS = [
  { value: 'public', label: 'Public' },
  { value: 'private', label: 'Private' },
  { value: 'acquired', label: 'Acquired' },
  { value: 'merged', label: 'Merged' },
  { value: 'defunct', label: 'Defunct' },
  { value: 'unknown', label: 'Unknown' },
] as const;

export const INACTIVE_CORPORATE_STATUSES = new Set(['acquired', 'merged', 'defunct']);

export const isInactiveCorporateStatus = (status?: string): boolean => {
  if (!status) return false;
  return INACTIVE_CORPORATE_STATUSES.has(status.trim().toLowerCase());
};

export const formatCorporateStatus = (value?: string): string => {
  if (!value) return 'Unknown';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
